import * as d3 from 'd3';

export const pinnedGreen = '#88eb24';

export function getMarkerGroup(
  svg: d3.Selection<SVGSVGElement, unknown, null, undefined>,
  position: [number, number],
  color: string,
  size: number,
  strokeWidth: number,
  label?: string,
) {
  const [factorX, factorY] = position;

  // Create a group for each marker and position it based on factorX and factorY.
  const markerGroup = svg.append('g');

  // Draw the "X" marker centered at (0,0) within the group.
  // First draw outlines for better visibility
  markerGroup
    .append('line')
    .attr('x1', -size)
    .attr('y1', -size)
    .attr('x2', size)
    .attr('y2', size)
    .attr('stroke', 'black')
    .attr('stroke-width', strokeWidth * 2);

  markerGroup
    .append('line')
    .attr('x1', -size)
    .attr('y1', size)
    .attr('x2', size)
    .attr('y2', -size)
    .attr('stroke', 'black')
    .attr('stroke-width', strokeWidth * 2);

  // Then draw the colored lines on top
  markerGroup
    .append('line')
    .attr('x1', -size)
    .attr('y1', -size)
    .attr('x2', size)
    .attr('y2', size)
    .attr('stroke', color)
    .attr('stroke-width', strokeWidth);

  markerGroup
    .append('line')
    .attr('x1', -size)
    .attr('y1', size)
    .attr('x2', size)
    .attr('y2', -size)
    .attr('stroke', color)
    .attr('stroke-width', strokeWidth);

  // Center yellow dot with a black border
  markerGroup
    .append('circle')
    .attr('r', 5)
    .attr('fill', color)
    .attr('stroke', 'black')
    .attr('stroke-width', 1)
    .attr('cx', 0)
    .attr('cy', 0);

  // Add label to the bottom right of the dot if provided
  if (label) {
    // Append a rect behind the text for background
    const textPadding = 2;
    const text = markerGroup
      .append('text')
      .attr('x', 10)
      .attr('y', 15)
      .attr('fill', 'black')
      .attr('font-size', '1.2em')
      .text(label);

    const bbox = text.node()!.getBBox();
    markerGroup
      .insert('rect', 'text') // Insert rect before text
      .attr('x', bbox.x - textPadding)
      .attr('y', bbox.y - textPadding)
      .attr('width', bbox.width + 2 * textPadding)
      .attr('height', bbox.height + 2 * textPadding)
      .attr('fill', 'rgba(255, 255, 255, 0.8)') // Transparent white background
      .attr('rx', 3) // Optional rounded corners
      .attr('ry', 3);
  }

  // Store each marker's data and group element in the markersLayers array.
  return { factorX, factorY, element: markerGroup };
}
